import 'phaser';
import CanvasInputPlugin from 'phaser3-rex-plugins/plugins/canvasinput-plugin';

/**
 * Returns the base Phaser game configuration
 * @returns {Phaser.Types.Core.GameConfig} Phaser game configuration
 */
export default function getConfig() {
  return {
    type: Phaser.AUTO,
    parent: 'game-container',
    width: 1280,
    height: 720,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    backgroundColor: 0xffffff,
    scene: [], // scenes are added manually after Game instantiation
    dom: {
      createContainer: true,
    },
    zoom: 1,
    fps: { target: 60 },
    physics: {
      default: 'arcade',
    },
    audio: {
      disableWebAudio: true,
    },
    plugins: {
      global: [
        {
          key: 'rexCanvasInputPlugin',
          plugin: CanvasInputPlugin,
          start: true,
        },
      ],
    },
  };
}
